// @ts-nocheck
export const EVENTS = {
  CLICK_ON_VIEW_PLANS: 'Click on view plans',
  VIEW_MEMBERSHIP_PAGE: 'View membership page V2',
};

export const initialStatePageKey = 'MembershipType';
export const MEMBERSHIP_PAGE_KEY = 'membership-landing';
export const prefixClass = 'ml';
